import Home from "./pages/Home"
import CustomNav from "./components/CustomNav"

function App() {
  return (
    <div className="App">
      <CustomNav />
      <Home />
    </div>
  )
}

export default App
